import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

export const IconContainer = styled(Box)(({ iconColor }) => ({
  color: iconColor,
  display: 'flex',
  alignItems: 'center',
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  variant: 'h5',
  component: 'h2',
}));
